import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import BackgroundImage from './Background.jpg'

export const Background = styled.div`
	min-height: 196px;
	width: 100%;
	background: url(${BackgroundImage}) no-repeat center/cover;
	position: absolute;

	${mobileMediaQuery(css`
		height: 80px;
	`)}
`
